"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateIfOperational = exports.validateIfNotDestroyed = void 0;
var constants_1 = require("../../logger/constants");
function validateIfNotDestroyed(log, readinessManager, method) {
    if (!readinessManager.isDestroyed())
        return true;
    log.error(constants_1.ERROR_CLIENT_DESTROYED, [method]);
    return false;
}
exports.validateIfNotDestroyed = validateIfNotDestroyed;
function validateIfOperational(log, readinessManager, method) {
    if (readinessManager.isReady() || readinessManager.isReadyFromCache())
        return true;
    log.warn(constants_1.CLIENT_NOT_READY, [method]);
    return false;
}
exports.validateIfOperational = validateIfOperational;
